import axios from "../http";

class User {
  //用户登录
  postUserLogin(data) {
    const url = "/zwy/api/pc/manager/login";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //用户退出登录
  postUserLogout() {
    const url = "/zwy/api/pc/manager/login/out";
    return axios.post(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 信鸽退出登录
  postCustomerUserLogout() {
    const url = "/zwy/api/pc/customer/login/out";
    return axios.post(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default User;
